(function(){
  var root = document.querySelector('[data-stats2]');
  if(!root) return;

  var nums = Array.prototype.slice.call(root.querySelectorAll('[data-count]'));
  if(!nums.length) return;

  function parseValue(raw){
    raw = String(raw || '').trim();

    var slash = raw.match(/^(\d+(?:\.\d+)?)\s*(\/\s*\d+.*)$/);
    if(slash){
      return { base: parseFloat(slash[1]), suffix: slash[2], decimals: 0 };
    }

    var m = raw.match(/^(\d+(?:\.\d+)?)\s*([kKmMbB])?\s*(\+|%|)?$/);
    if(m){
      var n = parseFloat(m[1]);
      var unit = (m[2] || '').toUpperCase();
      var tail = (m[3] || '');
      var decimals = (m[1].indexOf('.') > -1) ? (m[1].split('.')[1].length) : 0;
      return {
        base: n,
        suffix: (unit ? unit : '') + (tail ? tail : ''),
        decimals: decimals
      };
    }

    var any = raw.match(/(\d+(?:\.\d+)?)/);
    if(any){
      return { base: parseFloat(any[1]), suffix: raw.replace(any[1], ''), decimals: 0 };
    }

    return null;
  }

  function formatNumber(n, decimals){
    return decimals > 0 ? n.toFixed(decimals) : String(Math.round(n));
  }

  function easeInOutCubic(t){
    return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3)/2;
  }

  function animateOne(el){
    if(el.getAttribute('data-counted') === '1') return;

    var raw = el.textContent;
    var parsed = parseValue(raw);
    if(!parsed) return;

    var end = parsed.base;
    var suffix = parsed.suffix || '';
    var MAIN_DURATION = 1850;
    var TAIL_PAUSE    = 260;
    var START_DELAY   = 80;

    el.setAttribute('data-counted', '1');
    el.textContent = formatNumber(0, parsed.decimals) + suffix;

    setTimeout(function(){
      var start = performance.now();

      function tick(now){
        var t = Math.min(1, (now - start) / MAIN_DURATION);
        var eased = easeInOutCubic(t);
        var curr = end * eased;

        if(!el.__last) el.__last = 0;
        var shown = Math.max(el.__last, curr);
        el.__last = shown;

        el.textContent = formatNumber(shown, parsed.decimals) + suffix;

        if(t < 0.985){
          requestAnimationFrame(tick);
        } else {
          setTimeout(function(){
            el.textContent = formatNumber(end, parsed.decimals) + suffix;
          }, TAIL_PAUSE);
        }
      }

      requestAnimationFrame(tick);
    }, START_DELAY);
  }

  function run(){
    nums.forEach(animateOne);
  }

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){
        run();
        io.disconnect();
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '120px 0px 120px 0px'
  });

  io.observe(root);
})();